import { Plan } from "@growthzilla/billingui";
import { useEffect, useState } from "react";
import { BsFillCheckCircleFill } from "react-icons/bs";

export default function SinglePlan({
  plan,
  actions,
}: {
  plan: Plan;
  selectedPlan?: Plan;
  actions?: React.ReactNode;
}) {
  const [features, setFeatures] = useState<string[]>([]);

  useEffect(() => {
    try {
      const _data = JSON.parse(plan?.properties ?? "{}");
      setFeatures(_data["features"] ?? []);
    } catch (e) {
      setFeatures([]);
    }
  }, [plan]);

  return (
    <div
      key={`pricing${plan.name}`}
      className="flex w-[400px] flex-col gap-4 rounded bg-lightCard p-8 dark:bg-darkCard"
    >
      <h1 className="text-lg font-semibold text-primary">{plan.name}</h1>

      <div className="flex flex-col gap-2">
        <p className="text-5xl font-bold">{`${plan.amount.toLocaleString(
          "en-US",
          {
            style: "currency",
            maximumFractionDigits: 0,
            currency: plan.currency,
          },
        )}`}</p>
        <p className="text-xs font-medium text-gray-400">per month</p>
      </div>
      <hr />

      <ul className="mb-8 min-h-[8rem] space-y-2">
        {features.map((feature, idx) => (
          <li
            className="flex items-center text-sm text-gray-500 dark:text-gray-300"
            key={`pricing_feature${plan.name}${idx} `}
          >
            <div className="mr-3">
              <BsFillCheckCircleFill className="text-accentColor dark:text-darkAccentColor" />
            </div>
            <p className="font-medium">{feature}</p>
          </li>
        ))}
      </ul>
      {actions}
    </div>
  );
}
